import { Injectable } from "@angular/core"
import { Subject } from "rxjs"

@Injectable({ providedIn: 'root' }) export class ReAuthenticationService {
    private readonly _triggerAuthentication = new Subject<boolean>()
    readonly authenticate = this._triggerAuthentication.asObservable()
    readonly triggerAuthentication = (initialLogin: boolean) => {
        this._triggerAuthentication.next(initialLogin)
    }
}